import type { IconData } from '@stacksjs/iconify-core'

export const triangleF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m12.547 1.621l6.095 9.794A3 3 0 0 1 16.095 16H3.905a3 3 0 0 1-2.547-4.585L7.453 1.62a3 3 0 0 1 5.094 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default triangleF
